module.exports = __webpack_public_path__ + "img/placeholder.56c5f9a8.jpg";